import {CUT_TICKET} from '../constants/actionTypes';
import initial from './initialState';

export default function (state = initial.cutTicketState, action) {
  switch (action.type) {
    case CUT_TICKET.GET_LIST_SUCCESS:
      return {...state, items: action.data.items || [], count: action.data.total || 0};
    case CUT_TICKET.RELOAD:
      return {...state, reload: !state.reload};
    case CUT_TICKET.GET_DETAIL_SUCCESS:
      return {...state, detail: action.data};
    case CUT_TICKET.RESET_DETAIL:
      return {...state, detail: {}};
    case CUT_TICKET.SET_ITEM_YIELD_DETAIL:
      return {...state, itemYield: action.data || {}};
    case CUT_TICKET.SEND_YIELD_NOTIFY:
      return {...state, itemYield: action.data};
    default:
      return state;
  }
}
